import React from 'react';
import { Form, Select as SelectAntd } from 'antd';
import cn from 'classnames';
import { ReactComponent as Chevron } from 'static/icons/chevron.svg';
import { SelectProps } from './types';
import './style.scss';

export const Select: React.FC<SelectProps> = ({ className, name, label, rules, formItemProps, ...props }) => {
  return (
    <div className={cn('form-item_select', className)}>
      <Form.Item name={name} label={label} rules={rules} labelCol={{ span: 24 }} {...formItemProps}>
        <SelectAntd suffixIcon={<Chevron />} optionFilterProp="label" notFoundContent="Nothing found" {...props} />
      </Form.Item>
    </div>
  );
};
